import React from 'react';
import './HamburgerButton.css';

function HamburgerButton({ isOpen, onClick, className = '' }) {
    return (
        <button
            className={`hamburger-button ${isOpen ? 'open' : ''} ${className}`}
            onClick={onClick}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
        >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
        </button>
    );
}

export default HamburgerButton;
